export enum VsFsFileResponeType {
    string,
    object
}
